export default __webpack_public_path__ + "static/media/ontheway.372c16da.png";